(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp
      );

      this._fireballMovies = [];
      this._fireballCashOverlays = [];
      this._fireballPotOverlays = [];
      this._blueFireballWildOverlays = [];
      this._fireballsAreBlue = false;
      this._showBlueFireballWild = false;
    }

    createFireballMovies() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let fireball = resourceManager.createObject(
          "movie",
          "Symbol_Red_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Red_Fireball",
            anchor: 0.5,
          }
        );
        fireball.visible = false;

        let goldenFireball = resourceManager.createObject(
          "movie",
          "Symbol_Gold_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Gold_Fireball",
            anchor: 0.5,
          }
        );
        goldenFireball.visible = false;

        let mini = resourceManager.createObject(
          "movie",
          "Symbol_Green_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Green_Fireball",
            anchor: 0.5,
          }
        );
        mini.visible = false;

        let minor = resourceManager.createObject(
          "movie",
          "Symbol_Dark_Blue_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Dark_Blue_Fireball",
            anchor: 0.5,
          }
        );
        minor.visible = false;

        let major = resourceManager.createObject(
          "movie",
          "Symbol_Magenta_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Magenta_Fireball",
            anchor: 0.5,
          }
        );
        major.visible = false;

        let ultra = resourceManager.createObject(
          "movie",
          "Symbol_Orange_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Orange_Fireball",
            anchor: 0.5,
          }
        );
        ultra.visible = false;

        let mega = resourceManager.createObject(
          "movie",
          "Symbol_Dark_Red_Fireball",
          gfxObject.symbol.childContainer,
          {
            definition: "Symbol_Dark_Red_Fireball",
            anchor: 0.5,
          }
        );
        mega.visible = false;

        this._fireballMovies.push({
          fireball,
          goldenFireball,
          mini,
          minor,
          major,
          ultra,
          mega,
        });
      }
    }

    createFireballCashOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];
        let overlay = resourceManager.createObject(
          "text",
          "fireballCashOverlay",
          gfxObject.symbol.childContainer,
          {
            text: "???",
            fontDefinition: "fireball_font",
            fontSize: 26,
            maxWidth: 120,
            anchor: 0.5,
          }
        );
        overlay.visible = false;
        this._fireballCashOverlays.push(overlay);
      }
    }

    createFireballPotOverlays() {
      let totalAppertureSize =
        this.getReelSpinnerData().getTotalAppertureSize();
      for (let i = 0; i < totalAppertureSize; ++i) {
        let gfxObject = this._symbolGfxObjects[i];

        let miniOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMiniOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINI.png",
            anchor: 0.5,
          }
        );
        miniOverlay.visible = false;
        let minorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMinorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MINOR.png",
            anchor: 0.5,
          }
        );
        minorOverlay.visible = false;
        let majorOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMajorOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MAJOR.png",
            anchor: 0.5,
          }
        );
        majorOverlay.visible = false;
        let megaOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotMegaOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_MEGA.png",
            anchor: 0.5,
          }
        );
        megaOverlay.visible = false;

        let ultraOverlay = resourceManager.createObject(
          "sprite",
          "fireballPotUltraOverlay",
          gfxObject.symbol.childContainer,
          {
            fileName: "potBonus/Fireball_ULTRA.png",
            anchor: 0.5,
          }
        );
        ultraOverlay.visible = false;

        this._fireballPotOverlays.push({
          mini: miniOverlay,
          minor: minorOverlay,
          major: majorOverlay,
          mega: megaOverlay,
          ultra: ultraOverlay,
        });
      }
    }

    showBlueFireballWild(show) {
      this._showBlueFireballWild = show;
    }

    showFireballMovie(i, show, type = "Fireball") {
      if (show) {
        switch (type) {
          case "Fireball":
            this._fireballMovies[i].fireball.visible = true;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Golden":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = true;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Mini":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = true;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Minor":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = true;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Major":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = true;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Ultra":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = true;
            this._fireballMovies[i].mega.visible = false;
            break;
          case "Mega":
            this._fireballMovies[i].fireball.visible = false;
            this._fireballMovies[i].goldenFireball.visible = false;
            this._fireballMovies[i].mini.visible = false;
            this._fireballMovies[i].minor.visible = false;
            this._fireballMovies[i].major.visible = false;
            this._fireballMovies[i].ultra.visible = false;
            this._fireballMovies[i].mega.visible = true;
            break;
        }
      } else {
        this._fireballMovies[i].fireball.visible = false;
        this._fireballMovies[i].goldenFireball.visible = false;
        this._fireballMovies[i].mini.visible = false;
        this._fireballMovies[i].minor.visible = false;
        this._fireballMovies[i].major.visible = false;
        this._fireballMovies[i].ultra.visible = false;
        this._fireballMovies[i].mega.visible = false;
      }
    }

    bounceOverlays(index = 0, id = undefined) {
      let self = this;

      let orgOverlayXScale = self._fireballCashOverlays[index].scale.x;
      let orgOverlayYScale = self._fireballCashOverlays[index].scale.y;
      let ignoreOverlayScale = false;

      if (
        this._fireballCashOverlays[index].modifiedValue == undefined &&
        id !== undefined
      ) {
        this.updateSymbolIds([id]);

        orgOverlayXScale = self._fireballCashOverlays[index].scale.x;
        orgOverlayYScale = self._fireballCashOverlays[index].scale.y;
      }
      if (
        orgOverlayXScale === NaN ||
        orgOverlayXScale === undefined ||
        orgOverlayXScale === 0 ||
        this._fireballCashOverlays[index].modifiedValue == undefined
      ) {
        ignoreOverlayScale = true;
      }
      if (
        orgOverlayYScale === NaN ||
        orgOverlayYScale === undefined ||
        orgOverlayYScale === 0
      ) {
        ignoreOverlayScale = true;
      }
      timerManager.addTimer(
        300,
        function (progress) {
          let newScale = 1 + 0.2 * Math.abs(Math.sin(Math.PI * progress));
          if (!ignoreOverlayScale) {
            let newOverlayXScale =
              orgOverlayXScale + 0.1 * Math.abs(Math.sin(Math.PI * progress));
            let newOverlayYScale =
              orgOverlayYScale + 0.1 * Math.abs(Math.sin(Math.PI * progress));

            self._fireballCashOverlays[index].scale.set(
              newOverlayXScale,
              newOverlayYScale
            );
          }
          self._fireballPotOverlays[index].mini.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].minor.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].major.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].ultra.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].mega.scale.set(newScale, newScale);
        },
        function () {
          if (!ignoreOverlayScale) {
            self._fireballCashOverlays[index].scale.set(
              orgOverlayXScale,
              orgOverlayYScale
            );
          }
          self._fireballPotOverlays[index].mini.scale.set(1, 1);
          self._fireballPotOverlays[index].minor.scale.set(1, 1);
          self._fireballPotOverlays[index].major.scale.set(1, 1);
          self._fireballPotOverlays[index].ultra.scale.set(1, 1);
          self._fireballPotOverlays[index].mega.scale.set(1, 1);
        }
      );
    }

    bounceOverlaysSlow(index = 0) {
      let self = this;

      let orgOverlayXScale = self._fireballCashOverlays[index].scale.x;
      let orgOverlayYScale = self._fireballCashOverlays[index].scale.y;
      let ignoreOverlayScale = false;
      if (
        orgOverlayXScale === NaN ||
        orgOverlayXScale === undefined ||
        orgOverlayXScale === 0 ||
        this._fireballCashOverlays[index].modifiedValue == undefined
      ) {
        ignoreOverlayScale = true;
      }
      if (
        orgOverlayYScale === NaN ||
        orgOverlayYScale === undefined ||
        orgOverlayYScale === 0
      ) {
        ignoreOverlayScale = true;
      }
      timerManager.addTimer(
        600,
        function (progress) {
          let newScale = 1 + 0.4 * Math.abs(Math.sin(Math.PI * progress));
          if (!ignoreOverlayScale) {
            let newOverlayXScale =
              orgOverlayXScale + 0.1 * Math.abs(Math.sin(Math.PI * progress));
            let newOverlayYScale =
              orgOverlayYScale + 0.1 * Math.abs(Math.sin(Math.PI * progress));

            self._fireballCashOverlays[index].scale.set(
              newOverlayXScale,
              newOverlayYScale
            );
          }
          self._fireballPotOverlays[index].mini.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].minor.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].major.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].ultra.scale.set(newScale, newScale);
          self._fireballPotOverlays[index].mega.scale.set(newScale, newScale);
        },
        function () {
          if (!ignoreOverlayScale) {
            self._fireballCashOverlays[index].scale.set(
              orgOverlayXScale,
              orgOverlayYScale
            );
          }
          self._fireballPotOverlays[index].mini.scale.set(1, 1);
          self._fireballPotOverlays[index].minor.scale.set(1, 1);
          self._fireballPotOverlays[index].major.scale.set(1, 1);
          self._fireballPotOverlays[index].ultra.scale.set(1, 1);
          self._fireballPotOverlays[index].mega.scale.set(1, 1);
        }
      );
    }

    bounceSymbol(index = 0) {
      let self = this;
      timerManager.addTimer(
        300,
        function (progress) {
          let newScale = 1 + 0.2 * Math.abs(Math.sin(Math.PI * progress));
          self._fireballMovies[index].fireball.scale.set(newScale, newScale);
          self._fireballMovies[index].mini.scale.set(newScale, newScale);
          self._fireballMovies[index].minor.scale.set(newScale, newScale);
          self._fireballMovies[index].major.scale.set(newScale, newScale);
          self._fireballMovies[index].ultra.scale.set(newScale, newScale);
          self._fireballMovies[index].mega.scale.set(newScale, newScale);
        },
        function () {
          self._fireballMovies[index].fireball.scale.set(1, 1);
          self._fireballMovies[index].mini.scale.set(1, 1);
          self._fireballMovies[index].minor.scale.set(1, 1);
          self._fireballMovies[index].major.scale.set(1, 1);
          self._fireballMovies[index].ultra.scale.set(1, 1);
          self._fireballMovies[index].mega.scale.set(1, 1);
        }
      );
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      const symbols = resourceManager.getConfiguration().symbols;

      const possibleCashValues = [
        10, 20, 30, 40, 50, 100, 150, 200, 250, 500, 1000, 2000, 5000,
      ];
      const firstCashFireballId = symbols["Symbol_Fireball10"].ID;

      let stake = gameController.getCurrentModeStake(true);

      for (let i = 0; i < ids.length; ++i) {
        this._fireballCashOverlays[i].visible = false;
        this.showFireballMovie(i, false);
        this._fireballPotOverlays[i].mini.visible = false;
        this._fireballPotOverlays[i].minor.visible = false;
        this._fireballPotOverlays[i].major.visible = false;
        this._fireballPotOverlays[i].ultra.visible = false;
        this._fireballPotOverlays[i].mega.visible = false;

        let symId = ids[i];

        switch (symId) {
          case symbols["Symbol_Cash"].ID:
          // const baseVal = possibleCashValues[symId - firstCashFireballId];
          // let value =
          //   baseVal * (stake / gameData.gameConfig.winLinesForCashConversion);
          // if (this._fireballCashOverlays[i].modifiedValue) {
          //   value = this._fireballCashOverlays[i].modifiedValue;
          // } else {
          //   this._fireballCashOverlays[i].modifiedValue = value;
          // }

          // this.showFireballMovie(i, true);
          // this._fireballCashOverlays[i].visible = true;
          // this._fireballCashOverlays[i].setText(gdk.formatCurrency(value));
          // break;
          case symbols["Symbol_Fireball10"].ID:
          case symbols["Symbol_Fireball20"].ID:
          case symbols["Symbol_Fireball30"].ID:
          case symbols["Symbol_Fireball40"].ID:
          case symbols["Symbol_Fireball50"].ID:
          case symbols["Symbol_Fireball100"].ID:
          case symbols["Symbol_Fireball150"].ID:
          case symbols["Symbol_Fireball200"].ID:
          case symbols["Symbol_Fireball250"].ID:
          case symbols["Symbol_Fireball500"].ID:
          case symbols["Symbol_Fireball1000"].ID:
          case symbols["Symbol_Fireball2000"].ID:
          case symbols["Symbol_Fireball5000"].ID: {
            const baseVal = possibleCashValues[symId - firstCashFireballId];
            let value =
              baseVal * (stake / gameData.gameConfig.winLinesForCashConversion);
            if (this._fireballCashOverlays[i].modifiedValue) {
              value = this._fireballCashOverlays[i].modifiedValue;
            } else if (!value || value === "NaN") {
              value =
                possibleCashValues[0] *
                (stake / gameData.gameConfig.winLinesForCashConversion);
            }
            this.showFireballMovie(
              i,
              true,
              symId === symbols["Symbol_Cash"].ID ? "Golden" : "Fireball"
            );
            if (!this._fireballCashOverlays[i].shouldBeHidden) {
              this._fireballCashOverlays[i].visible = true;
            }
            let currency =
              PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
                value / 100
              );
            if (!this._fireballCashOverlays[i].shouldNotBeSet) {
              if (
                currency !== this._fireballCashOverlays[i].text ||
                this._fireballCashOverlays[i].scale.x <= 0 ||
                this._fireballCashOverlays[i].scale.y <= 0
              ) {
                this._fireballCashOverlays[i].setText(currency);
                this._fireballCashOverlays[i].modifiedValue = value;
              }
            }
            break;
          }
          case symbols["Symbol_Mega"].ID: {
            this._fireballPotOverlays[i].mega.visible = true;
            this.showFireballMovie(i, true, "Mega");
            break;
          }
          case symbols["Symbol_Ultra"].ID: {
            this._fireballPotOverlays[i].ultra.visible = true;
            this.showFireballMovie(i, true, "Ultra");
            break;
          }
          case symbols["Symbol_Major"].ID: {
            this._fireballPotOverlays[i].major.visible = true;
            this.showFireballMovie(i, true, "Major");
            break;
          }
          case symbols["Symbol_Minor"].ID: {
            this._fireballPotOverlays[i].minor.visible = true;
            this.showFireballMovie(i, true, "Minor");
            break;
          }
          case symbols["Symbol_Mini"].ID: {
            this._fireballPotOverlays[i].mini.visible = true;
            this.showFireballMovie(i, true, "Mini");
            break;
          }
          case symbols["Symbol_FireballX2"].ID: {
            this.showFireballMovie(i, true);
            this._fireballCashOverlays[i].visible = true;
            if ("" !== this._fireballCashOverlays[i]) {
              this._fireballCashOverlays[i].setText("");
            }
            break;
          }
        }
      }
    }

    useBlazingZoneMask() {
      this.removeChild(this.mask);
      delete this.mask;

      const { x, width } = this.Props.clipRect;
      this.createClipRect({ x, y: -73, width, height: 149 });
    }

    useRegularMask() {
      this.removeChild(this.mask);
      delete this.mask;

      this.createClipRect(this.Props.clipRect);
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
    reelSpinnerVisual.createFireballMovies();
    reelSpinnerVisual.createFireballCashOverlays();
    reelSpinnerVisual.createFireballPotOverlays();
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualSCS",
    create,
    initialise,
    getRequiredFiles
  );
})();
